import { useCallback } from 'react';
import { useAsync } from './useAsync';
import { listAssets, getAsset } from '@/services/assets';
import type { Asset } from '@/types/api';

export function useAssets(offset = 0, limit = 50) {
  const fn = useCallback(() => listAssets(offset, limit), [offset, limit]);
  return useAsync<Asset[]>(fn);
}

export function useAsset(id: number | null) {
  const fn = useCallback(
    () => (id != null ? getAsset(id) : Promise.reject(new Error('No ID'))),
    [id],
  );
  return useAsync<Asset>(id != null ? fn : null);
}
